/* BMM Autosports — theme interactions */
(function () {
  'use strict';

  // Mobile nav toggle
  function initMobileNav() {
    var burger = document.querySelector('[data-burger]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!burger || !nav) return;
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  // Filters drawer toggle (mobile collection page)
  function initFacets() {
    var toggle = document.querySelector('[data-facets-toggle]');
    var facets = document.querySelector('[data-facets]');
    if (!toggle || !facets) return;
    toggle.addEventListener('click', function () {
      facets.classList.toggle('open');
    });
    // auto-submit on checkbox change
    var form = facets.querySelector('form');
    if (form) {
      facets.querySelectorAll('input[type=checkbox]').forEach(function (cb) {
        cb.addEventListener('change', function () { form.submit(); });
      });
    }
  }

  // Sort dropdown -> reload with sort param
  function initSort() {
    var sel = document.querySelector('[data-sort]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  }

  // Product gallery thumb switch
  function initGallery() {
    var main = document.querySelector('[data-main-img]');
    if (!main) return;
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.dataset.full || t.src;
      });
    });
  }

  // Live cart count via Shopify AJAX API
  function refreshCart() {
    var el = document.querySelector('[data-cart-count]');
    if (!el) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initFacets();
    initSort();
    initGallery();
    refreshCart();
  });
})();
